/**
 * 푸시 토픽 목록
 * - all_devices 는 전체 사용자에게 간편하게 푸시를 발송하기 위해 할당한 토픽
 * - 토픽을 구독한 대상을 firebase 서버에서 조회할 수 없으므로 일단 전체 사용자만 적용해둠
 * - 로그인 기반으로 추가하거나 변경할 땐 topicsToSubscribe 부분을 검색해서 해당 로직을 점검해야 함
 */
export const PUSH_TOPICS = ['all_devices', 'member'] as const;

export type PushTopic = (typeof PUSH_TOPICS)[number];

export interface PushMessage {
    notification: {
        title: string;
        body: string;
    };
    data?: {
        link?: string;
        /**
         * 푸시를 발송할 때 자동으로 추가됨
         * - PushService.ts
         */
        campaignKey?: string;
    };
}

/**
 * 푸시 캠페인
 * - 푸시를 발송할 땐 중복되지 않게 이 캠페인명 뒤에 타임스탬프를 붙여서 보냄
 */
export type PushCampaign = 'test' | 'notice' | 'devlog';
